function ReviewedStatus() {
  return (
    <div className="inline-flex items-center justify-center px-[10px] py-[2px] rounded-[16px] bg-[#EAF3FF] font-OpenSansSemiBold font-[600] text-[#0058E5] text-[14px] leading-[20px] [mix-blend-mode:multiply]">
      Reviewed
    </div>
  );
}

export default ReviewedStatus;
